import * as React from 'react';
const { useCallback, useMemo } = React;
import {
	withRouter,
	RouteComponentProps,
	Switch,
	Route,
	Redirect,
} from 'react-router-dom';
import TabPicker, { TabPickerDataSourceItem } from '../tab-picker';

import {
	Root,
	ContentLayout,
	HeaderLayout,
} from './styled';


type RouteType = {
	path: string;
	sysName: string;
	name: string;
}

type DataSourceItem = TabPickerDataSourceItem;

export type NestedRoutingProps = {
	appearance?: 'default' | 'transparent';
	routes: Array<RouteType>;
	componentsMap: Record<string, React.ComponentType>;
} & RouteComponentProps;

const NestedRouting: React.SFC<NestedRoutingProps> = (props) => {
	const {
		appearance,
		routes,
		componentsMap,
		location,
		history,
	} = props;
	const handleNavigate = useCallback((_, __, item: DataSourceItem) => history.push(item.value), []);
	const dataSource = useMemo(() => resolveRoutesToDataSourceItems(routes), [routes]);

	return (
		<Root>
			<HeaderLayout appearance={appearance}>
				<TabPicker
					value={location.pathname}
					dataSource={dataSource}
					negativeOffset={40}
					onChange={handleNavigate}
				/>
			</HeaderLayout>
			<ContentLayout>
				<Switch>
					{
						routes.map(route => (
							<Route
								key={route.sysName}
								path={route.path}
								component={componentsMap[route.sysName] || componentsMap['default']}
							/>
						))
					}
					<Redirect to={routes[0].path} />
				</Switch>
			</ContentLayout>
		</Root>
	);
}

function resolveRoutesToDataSourceItems(routes: Array<RouteType>): Array<DataSourceItem> {
	return routes.map(({ path, ...rest }) => ({ value: path, ...rest }));
}

NestedRouting.displayName = 'NestedRouting';
NestedRouting.defaultProps = {
	appearance: 'default',
};

export default withRouter(NestedRouting);
